import { Box, Text, type FlexProps } from '@radix-ui/themes'
import clsx from 'clsx'
import { ArrowLeft, ArrowRight } from 'lucide-react'
import { Button } from './button'
import Hstack from './hstack'

type PaginationProps = FlexProps & {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  className?: string
}

export default function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  className,
  ...props
}: PaginationProps) {
  const canGoPrevious = currentPage > 1
  const canGoNext = currentPage < totalPages

  const handlePrevious = () => {
    if (canGoPrevious) {
      onPageChange(currentPage - 1)
    }
  }

  const handleNext = () => {
    if (canGoNext) {
      onPageChange(currentPage + 1)
    }
  }

  return (
    <Hstack {...props} gap={'16px'} className={clsx(className)}>
      <Button
        onClick={handlePrevious}
        disabled={!canGoPrevious}
        className={clsx(
          'border border-[#EAECF0]',
          'bg-white',
          'hover:bg-white'
        )}
      >
        <ArrowLeft className='!h-[22px] !w-[22px]' color='#1D2939' />
        <Text className='text-[14px] font-medium text-[#475467]'>Previous</Text>
      </Button>

      <Hstack className='flex items-center !gap-[4px] text-[14px] font-normal text-[#475467]'>
        <span>Page</span>
        <Box
          py={'8px'}
          px={'14px'}
          className='rounded-[8px] border border-[#EAECF0]'
        >
          <span>{currentPage}</span>
        </Box>
        <span>
          of <span className='ml-1'>{totalPages}</span>
        </span>
      </Hstack>

      <Button
        onClick={handleNext}
        disabled={!canGoNext}
        className={clsx(
          'border border-[#EAECF0]',
          'bg-white',
          'hover:bg-white'
        )}
      >
        <Text className='text-[14px] font-medium text-[#475467]'>Next</Text>
        <ArrowRight className='!h-[22px] !w-[22px]' color='#1D2939' />
      </Button>
    </Hstack>
  )
}
